import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';

interface ProductCategoryPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  onRegister: (categoryData: { name: string }) => void;
}

const ProductCategoryPopup: React.FC<ProductCategoryPopupProps> = ({
  popupOpen,
  setPopupOpen,
  onRegister,
}) => {
  // Esquema de validación con Yup
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'El nombre debe tener al menos 2 caracteres')
      .required('El nombre de la categoría de producto es obligatorio'),
  });

  // Inicialización de Formik
  const formik = useFormik({
    initialValues: {
      id: 0,
      name: '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      onRegister(values);
      resetForm();
      setPopupOpen(false);
    },
  });

  // 📌 useEffect para reiniciar el formulario cuando se cierre el modal
  useEffect(() => {
    if (!popupOpen) {
      formik.resetForm(); // Reinicia los valores cuando el modal se cierra
    }
  }, [popupOpen]); // Se ejecuta cada vez que `popupOpen` cambie

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Agregar Categoría de Producto"
      maxWidth="max-w-md" // o el tamaño que necesites
    >
      <form onSubmit={formik.handleSubmit} className="mt-4">
        {/* Nombre de la Categoría */}
        <InputField
          label="Nombre"
          name="name"
          type="text"
          placeholder="Ingrese nombre de la categoría"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name && formik.errors.name
              ? formik.errors.name
              : undefined
          }
          iconKey='edit'
        />

        <button
          type="submit"
          className="w-full rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Categoría
        </button>
      </form>
    </FormModal>
  );
};

export default ProductCategoryPopup;
